/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./RevertRemovalDialog.vue?vue&type=template&id=75c10fbf"
import script from "./RevertRemovalDialog.vue?vue&type=script&lang=js"
export * from "./RevertRemovalDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75c10fbf')) {
      api.createRecord('75c10fbf', component.options)
    } else {
      api.reload('75c10fbf', component.options)
    }
    module.hot.accept("./RevertRemovalDialog.vue?vue&type=template&id=75c10fbf", function () {
      api.rerender('75c10fbf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patients/RevertRemovalDialog.vue"
export default component.exports